"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Dropdown_styled_exports = {};
__export(Dropdown_styled_exports, {
  StyledChevronIcon: () => StyledChevronIcon,
  StyledDropdown: () => StyledDropdown,
  StyledDropdownTitle: () => StyledDropdownTitle,
  StyledIcon: () => StyledIcon,
  StyledInput: () => StyledInput,
  StyledLabelTitle: () => StyledLabelTitle,
  StyledWrapperTitle: () => StyledWrapperTitle
});
module.exports = __toCommonJS(Dropdown_styled_exports);
var import_styled_components = __toESM(require("styled-components"));
var import_atoms = require("../../atoms");
var import_mixins = require("../../../themes/mixins");
var getTitleColor = function getTitleColor2(theme, errorMode, darkMode, disabled) {
  if (darkMode) {
    if (disabled) {
      return theme.colors.n[30];
    }
    return errorMode ? theme.colors.n[100] : theme.colors.white;
  }
  return disabled ? theme.colors.n[60] : theme.colors.n[100];
};
var getInputDropdownBackgroundColor = function getInputDropdownBackgroundColor2(theme, errorMode, darkMode) {
  if (darkMode) {
    return errorMode ? theme.colors.status.error["20"] : theme.colors.black;
  }
  return theme.colors.white;
};
var getInputDropdownBorder = function getInputDropdownBorder2(theme, errorMode, borderLess) {
  if (errorMode) {
    return "1px solid ".concat(theme.colors.incorrect.base);
  }
  return borderLess ? "none" : "1px solid ".concat(theme.colors.beige[180]);
};
var getIconColor = function getIconColor2(theme, errorMode, darkMode, disabled, isChevron) {
  if (darkMode) {
    if (disabled) {
      return theme.colors.n[30];
    }
    return errorMode ? theme.colors.n[100] : theme.colors.white;
  }
  if (disabled) {
    return theme.colors.n[60];
  }
  return isChevron ? theme.colors.pr.base : theme.colors.n[100];
};
var StyledDropdown = import_styled_components.default.div.withConfig({
  displayName: "Dropdownstyled__StyledDropdown",
  componentId: "sc-1cc3k8k-0"
})(function(_ref) {
  var theme = _ref.theme, isLarge = _ref.isLarge, customizedWidth = _ref.customizedWidth, customizeHeight = _ref.customizeHeight, errorMode = _ref.errorMode, borderLess = _ref.borderLess, darkMode = _ref.darkMode, disabled = _ref.disabled;
  return (0, import_styled_components.css)(["display:flex;background:", ";font-family:", ";width:", ";height:", ";border:", ";", ";padding:6px 14px 6px 12px;box-sizing:border-box;margin:auto 2px;", " &:focus{", ";outline:none;-webkit-appearance:none;}&:focus-visible{", ";box-shadow:", ";outline:none;}"], getInputDropdownBackgroundColor(theme, errorMode, darkMode), theme.typography.fonts.primary, isLarge ? "172px" : customizedWidth || "152px", customizeHeight || "56px", getInputDropdownBorder(theme, errorMode, borderLess), (0, import_mixins.withBorderRadius)(theme.measurements.small), disabled && (0, import_styled_components.css)(["background:", ";cursor:not-allowed;border:none;color:", ";box-shadow:none;"], darkMode ? theme.colors.n[80] : theme.colors.n[10], darkMode ? theme.colors.n[30] : theme.colors.n[60]), !disabled && (0, import_mixins.withBorder)(darkMode ? theme.colors.white : theme.colors.n["100"], "2px"), !disabled && (0, import_mixins.withBorder)(darkMode ? theme.colors.white : theme.colors.n["100"], "2px"), disabled ? "none" : "0 0 0 2px ".concat(darkMode ? theme.colors.n["100"] : theme.colors.white, ",\n          0 0 0 3px ").concat(theme.colors.beige[180]));
});
var StyledDropdownTitle = import_styled_components.default.span.withConfig({
  displayName: "Dropdownstyled__StyledDropdownTitle",
  componentId: "sc-1cc3k8k-1"
})(["align-items:center;display:flex;flex-direction:row;justify-content:space-between;width:100%;"]);
var StyledWrapperTitle = import_styled_components.default.div.withConfig({
  displayName: "Dropdownstyled__StyledWrapperTitle",
  componentId: "sc-1cc3k8k-2"
})(function(_ref2) {
  var theme = _ref2.theme, darkMode = _ref2.darkMode, errorMode = _ref2.errorMode, disabled = _ref2.disabled;
  return (0, import_styled_components.css)(["font-size:", ";line-height:24px;color:", ";flex-grow:1;text-align:left;width:75%;span{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:block;}"], theme.typography.sizes.medium, getTitleColor(theme, errorMode, darkMode, disabled));
});
var StyledLabelTitle = import_styled_components.default.div.withConfig({
  displayName: "Dropdownstyled__StyledLabelTitle",
  componentId: "sc-1cc3k8k-3"
})(function(_ref3) {
  var theme = _ref3.theme;
  return (0, import_styled_components.css)(["text-align:left;font-size:", ";line-height:", ";color:inherit;width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"], theme.typography.sizes.small, theme.measurements.extraExtraLarge);
});
var StyledIcon = (0, import_styled_components.default)(import_atoms.Icon).withConfig({
  displayName: "Dropdownstyled__StyledIcon",
  componentId: "sc-1cc3k8k-4"
})(function(_ref4) {
  var theme = _ref4.theme, disabled = _ref4.disabled, darkMode = _ref4.darkMode, errorMode = _ref4.errorMode;
  return (0, import_styled_components.css)(["color:", ";margin-right:8px;font-size:17px;line-height:24px;width:10%;"], getIconColor(theme, errorMode, darkMode, disabled, false));
});
var StyledChevronIcon = (0, import_styled_components.default)(import_atoms.Icon).withConfig({
  displayName: "Dropdownstyled__StyledChevronIcon",
  componentId: "sc-1cc3k8k-5"
})(function(_ref5) {
  var theme = _ref5.theme, disabled = _ref5.disabled, darkMode = _ref5.darkMode, errorMode = _ref5.errorMode;
  return (0, import_styled_components.css)(["color:", ";font-size:20px;line-height:24px;"], getIconColor(theme, errorMode, darkMode, disabled, true));
});
var StyledInput = import_styled_components.default.input.withConfig({
  displayName: "Dropdownstyled__StyledInput",
  componentId: "sc-1cc3k8k-6"
})(function(_ref6) {
  var theme = _ref6.theme;
  return (0, import_styled_components.css)(["width:100%;border:none;outline:none;font-size:", ";line-height:24px;color:inherit;padding:", ";background-color:transparent;:disabled{cursor:not-allowed;}"], theme.typography.sizes.medium, theme.measurements.zero);
});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  StyledChevronIcon,
  StyledDropdown,
  StyledDropdownTitle,
  StyledIcon,
  StyledInput,
  StyledLabelTitle,
  StyledWrapperTitle
});
//# sourceMappingURL=Dropdown.styled.js.map